'use strict';
angular.module('weixinServiceModule', ['weixinBtnServiceModule', 'wechatBtnServiceModule'])
    . factory('weixinService', ['editingCenterService', '$state', function(editingCenterService, $state) {
        
        /**
         * [getDetailUrl 获取预览页]
         *
         * @param   {[type]}  doctypeID    [doctypeID description]
         * @param   {[type]}  mediatypeID  [mediatypeID description]
         *
         * @return  {[type]}               [return description]
         */
        function getDetailUrl() {
            let baseUrl = window.location.origin + '/xjmediaCloud/#/';
            let previewUrl = '';
            previewUrl += `weixinpreview?wxmetadataid=${$state.params.wxmetadataid}&wxchannelid=${$state.params.wxchannelid}&wxchnldocid=${$state.params.wxchnldocid}&wxplatform=${$state.params.wxplatform}`;
            return baseUrl + previewUrl;
        }

        /**
         * [getOprType 获取操作平台类型]
         *
         * @return  {[type]}  [return description]
         */
        function getOprType() {
            return {
                '0': 'wechat.daibian',
                '1': 'wechat.daishen',
                '2': 'wechat.yiqianfa'
            }[$state.params.platform] || 'wechat.daibian';
        }
        return {

            /**
             * [addFuture 为控制器作用域增加通用功能]
             *
             * @param   {[type]}  vm              [vm description]
             * @param   {[type]}  methodNameList  [methodNameList description]
             *
             * @return  {[type]}                  [return description]
             */
            addFuture: function (vm, methodNameList) {
                for (var i = 0; i < methodNameList.length; i++) {
                    let methodName = methodNameList[i];
                    vm[methodName] = this[methodName];
                }
                return vm;
            },

            /**
             * [sendmessage 发送消息到IM]
             *
             * @return  {[type]}  [return description]
             */
            sendmessage: function () {
                let that = this;
                this.save(true).then((data) => {
                    const outerSourceId = that.list.METADATAID;
                    const title = that.list.TITLE;
                    let articleDocType = editingCenterService.getDocTypeId();
                    let articleMediaType = editingCenterService.getEditPageMediaType();
                    let url = getDetailUrl();
                    const extraInfo = {
                        'articleDocType': articleDocType,
                        'articleMediaType': articleMediaType,
                        'articleUrl': url,
                        'metadataid': outerSourceId,
                        // eslint-disable-next-line no-unneeded-ternary
                        'isawaitrevise': $state.params.isawaitrevise ? true : false,
                        'doctypeid': articleDocType,
                        'channelid': $state.params.wxchannelid,
                        'chnldocid': $state.params.wxchnldocid
                    };
                    const info = {
                        messageBody: {
                            content: '',
                            extraInfo: JSON.stringify(extraInfo),
                            messageType: 'ARTICLE_DOC', 
                            outerSourceId: outerSourceId,
                            platform: '',
                            title: title
                        },
                        outerSourceId: '',
                        oprType: getOprType(),
                        objId: $state.params.wxchannelid
                    };
                    editingCenterService.sendToStudio(info).then(function(result){
                        if (result.ISSUCCESS === 'true') {
                            setTimeout(() => {
                                window.close();
                            }, 2000);
                        }
                    });
                });
            },

            /**
             * [initWechatBtns description] 初始化编辑页按钮
             * @return {[type]} [description]
             */
            initWechatBtns: function() {
                var compileArrays = [{
                    'RIGHTINDEX': 242,
                    'OPERDESC': '送审',
                    'OPERFUN': 'weixinCompileSend'
                }, {
                    'RIGHTINDEX': 243,
                    'OPERDESC': '送签',
                    'OPERFUN': 'weixinCompileSignDirect'
                },{
                    'RIGHTINDEX': 856,
                    'OPERDESC': '发送',
                    'OPERFUN': 'sendmessage'
                }];
                var pendingArrays = [{
                    'RIGHTINDEX': 257,
                    'OPERDESC': '送签',
                    'OPERFUN': 'weixinPendSignDirect'
                }, {
                    'RIGHTINDEX': 258,
                    'OPERDESC': '撤稿',
                    'OPERFUN': 'weixinPendRejectionDraft'
                },{
                    'RIGHTINDEX': 857,
                    'OPERDESC': '发送',
                    'OPERFUN': 'sendmessage'
                }];
                var signArrays = [
                    {
                        'RIGHTINDEX': 858,
                        'OPERDESC': '发送',
                        'OPERFUN': 'sendmessage'
                    }
                // {
                //     "RIGHTINDEX": 263,
                //     "OPERDESC": "取消送签",
                //     "OPERFUN": "weixinSignRevoke"
                // }
                ];
                var arrayWebsiteBtns = [compileArrays, pendingArrays, signArrays];
                return arrayWebsiteBtns;
            },
            initDocGenre: function() {
                var DocGenre = [{
                    'name': '无体裁',
                    'value': '无体裁'
                }, {
                    'name': '一版头条消息',
                    'value': '一版头条消息'
                }, {
                    'name': '其它版头条消息',
                    'value': '其它版头条消息'
                }, {
                    'name': '其它消息',
                    'value': '其它消息'
                }, {
                    'name': '调查类报道',
                    'value': '调查类报道'
                }, {
                    'name': '来信',
                    'value': '来信'
                }, {
                    'name': '重要评论文章',
                    'value': '重要评论文章'
                }, {
                    'name': '社论、特约评论员',
                    'value': '社论、特约评论员'
                }, {
                    'name': '通讯',
                    'value': '通讯'
                }, {
                    'name': '简讯',
                    'value': '简讯'
                }, {
                    'name': '本报评论员、署名评论',
                    'value': '本报评论员、署名评论'
                }, {
                    'name': '摄影作品',
                    'value': '摄影作品'
                }, {
                    'name': '短评（含编辑按、编后、小言论等）',
                    'value': '短评（含编辑按、编后、小言论等）'
                }, {
                    'name': '内参',
                    'value': '内参'
                }, {
                    'name': '新华社',
                    'value': '新华社'
                }, {
                    'name': '文摘',
                    'value': '文摘'
                }];
                return DocGenre;
            },
            queryCurrChannel: function(channelid) {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'getChannelPath',
                    ChannelId: channelid
                };
                var deffered = $q.defer();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    deffered.resolve(data);
                });
                return deffered.promise;
            }
        };
    }]);
